import { render } from "./ActionSuccess.vue?vue&type=template&id=4d5672dc"
import script from "./ActionSuccess.vue?vue&type=script&lang=js"
export * from "./ActionSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__